<template>
  <div>
    <v-layout wrap justify-center pt-10>
      <v-flex xs12 sm12 md12 lg12>
        <v-layout wrap justify-center style="background-color: #3d673a;">
          <v-flex xs12 sm12 md11 lg11>
            <v-layout wrap justify-center pa-3>
              <v-flex xs12>
                <h2 class="text-center text-bold" style="color:#ffcf59;font-size:35px;font-family:poppinsbold">Thesis Film</h2>
              </v-flex>
              
              <v-flex xs12 sm6 md4 lg3 v-for="(alumni, index) in alumniList" :key="index" class="pa-lg-3 pa-md-3 pa-sm-3 pa-0 pt-4">
                <v-card class="pa-4 d-flex flex-column justify-space-between" style="background-color: #ffcf59; height: 100%;">
                  <!-- Content Section -->
                  <div>
                    <v-avatar color="white" size="150" class="mx-auto mb-2">
                      <img :src="alumni.image" alt="Alumni Image" />
                    </v-avatar>
                    <h3 class="text-center text-bold hidden-md-and-up" style="color:#3d673a;font-family:poppinsbold">{{ alumni.name }}</h3>
                     <h3 class="text-left text-bold hidden-sm-and-down" style="color:#3d673a;font-family:poppinsbold">{{ alumni.name }}</h3>
                    <h3 style="color:#3d673a;font-family:poppinsbold " class="text-center mb-1 text-bold hidden-md-and-up">{{ alumni.cohort }}</h3>
                    <h3 style="color:#3d673a;font-family:poppinsbold  " class="text-left mb-1 hidden-sm-and-down text-bold">{{ alumni.cohort }}</h3>

                    <p style="color:grey;font-family:poppinsregular" class="text-left">{{ alumni.designation }}
                      <br>
                   <span style="color:black;font-family:poppinsregular">{{ alumni.desc }}</span>   
                    </p>
                  </div>
    
                  <!-- Button Section -->
          <div class="mt-auto">
            <v-btn
              block
              style="background-color: #3d673a;"
              class="mt-4"
              text
              @click="openshowVideo(alumni.videoLink)"
            >
              <span style="color: #ffcf59; text-decoration:underline">
                Watch Video
              </span>
            </v-btn>
          </div>
                </v-card>
              </v-flex>
    
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
     <!-- Video Dialog -->
     <v-dialog v-model="showVideo" width="900px" persistent>
      <v-card>
        <v-card-title class="headline">Watch Video</v-card-title>
        <v-card-text>
          <iframe
            v-if="currentVideo"
            :src="currentVideo"
            width="100%"
            height="400"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeVideo">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideo: false,
      currentVideo: "",
      alumniList: [
        {
          name: "Nayantara Siruguri",
          cohort: "(2020-2022 Cohort)",
          designation: "Nature Education Coordinator at Canopy Collective",
          image: require("../assets/Images/25. Nayantara Siruguri.jpg"),
          desc: "Thesis Title: Bats in the classroom: the effects of an environmental education (EE) intervention on children's perception of bats in Maharashtra, India",
          videoLink: "https://www.youtube.com/embed/laoyeTLkEIY",
        },
        {
          name: "Tanaya Rele",
          cohort: "(2021-2023 Cohort)",
          designation:
            "Project Assistant at Nature Classrooms, Nature Conservation Foundation",
            image: require("../assets/Images/30. Tanaya Rele.jpg"),
          desc: "Thesis Title: The Greens in the Grey: Perceptions of people towards the aesthetic and ecological aspects of urban parks in Mumbai, India",
          videoLink: "https://www.youtube.com/embed/5b0hOmSYoKA",
        },
        {
          name: "Rajiv N V ",
          cohort: "(2021-2023 Cohort)",
          designation:
            "Research Fellow at the National Centre for Biological Sciences (NCBS)",
          desc: "Thesis Title: Intergenerational transmission of cultural values: A study on sacred groves in Siddapur, India",
          image: require("../assets/Images/34. N V Rajiv1.jpg"),
          videoLink: "https://www.youtube.com/embed/tI4_wOlFtQk",
        },
        {
          name: "Aditi Rao",
          cohort: " ( 2022-2024 Cohort)",
          designation:
            "Fellow at Nature Classrooms, Nature Conservation Foundation",
            image: require("../assets/Images/IMG_87001.jpeg"),
          desc: "Thesis Title: Threads of Time: Intergenerational Transmission of Traditional Ecological Knowledge About Tubers in Uttara Kannada’s Kunbi Community",
          videoLink: "https://www.youtube.com/embed/qI6Ye3K6CUY",
        },
      ],
    };
  },
  methods: {
    openshowVideo(videoLink) {
      this.currentVideo = videoLink;
      this.showVideo = true;
    },
    closeVideo() {
      this.showVideo = false;
      this.currentVideo = null;
    },
  },
};
</script>

<style scoped>
.text-bold {
  font-weight: bold;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}
.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>